<template>
  <div class="CATEGORY_NAME">
    <label for="" class="input-wrap">
      <input :value="category.id" type="text" hidden />
      <Input v-model="valuedata" type="text" disabled />
      <Icon v-if="!isDisabled" type="ios-close" class="clear" @click.stop="clearInput" />
      <Icon type="ios-funnel-outline" class="funnel" v-if="isMultiple" @click.stop="openModal" />
      <i class="funnel ark-icon iconfont iconbj_xldan" v-if="!isMultiple && !isDisabled" @click.stop="openModal" />
    </label>
    <Modal v-model="showTree" :title="t('类目名称')" :mask="true" closable footer-hide width="462" titleAlign="left">
      <div style="height: 60vh; overflow: auto" class="model__" v-loading="loading">
        <Input v-model="keyword" type="text" style="margin-bottom: 5px;" />
        <el-tree :props="props"
                 :data="data"
                 ref="tree"
                 :show-checkbox="isMultiple"
                 node-key="id"
                 @node-click="handleNodeClick"
                 :default-expanded-keys="expandedNode"
                 :default-checked-keys="checkedNode"
                 :filter-node-method="filterNode" />
      </div>
      <OmsButton :btn-config="btnConfig" class="modal-footer" />
    </Modal>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import interceptorsModule from '@/config/interceptors'

export default {
  name: 'CategoryName',
  props: {
    isShowCheckbox: {
      type: Boolean,
      default: true
    },
    options: {
      type: Object
    },
    isLastNode: {
      type: Boolean,
      default: false
    },
    defaultCategoryType: {
      type: String|Number
    }
  },
  data() {
    return {
      objid: -1,
      loading: true,
      showTree: false,
      category: { id: '', name: '' }, // 当前选中商品品类
      keyword: '',
      valuedata: null,
      data: [],
      props: {
        label: 'title',
        children: 'children',
      },
      selectNodeTitle: [],
      expandedNode: [],
      checkedNode: [],
      count: 1,
      btnConfig: {
        typeAll: 'default',
        btnsite: 'right',
        buttons: [
          {
            text: t('取消'),
            btnclick: () => {
              this.showTree = false;
            },
          },
          {
            text: t('确定'),
            type: 'primary',
            btnclick: () => {
              this.confirm()
            },
          },
        ],
      },
      curQueryTreeConds: {
        categoryType: '', // 类型
        platformId: '', // 平台
      }
    };
  },
  async created() {
    this.handleTreeConds()
    // 商品SPU新增只展示后台类目
    if (this.$route.params.itemId == 'New' && this.$route.params.tableName == 'PS_C_PRO') {
      this.curQueryTreeConds.categoryType = '2'
    }
    await this.getTreeData();
    // 复制页面-商品品类初始化数据
    if (this.$route.params.itemId == 'New') {
      this.init()
    }
  },
  mounted() {
    console.log(this.options)
    this.$on('formItemChange', (res) => {
      console.log('表单变更监听成功::')
      console.log(res)
      this.handleTreeConds(res)
    })
    // 详情页面-点击保存按钮，通知框架更新
    $('#actionMODIFY').on('click', () => {
      // 类目不可编辑时，则不通知框架变更，否则修改任何内容，操作日志都会多出一条【商品类目】的修改记录，eg: 商品SPU。
      !this.isDisabled && this.init()
    });
  },
  computed: {
    // 是否多选
    isMultiple: {
      get() {
        if (!this.isShowCheckbox) {
          return false
        } else if (!this.$route.params.hasOwnProperty('itemId')) {
          // 商品SPU列表批量修改- 单选
          return this.options.webconf && this.options.webconf.batchModal ? false : true
        }
      }
    },
    isDisabled() {
      const { tableName, itemId } = this.$route.params
      let flag = false
      // 商品SPU详情不可编辑
      if (tableName == 'PS_C_PRO' && itemId != 'New') {
        flag = true
      }
      return flag
    }
  },
  watch: {
    keyword(val) {
      this.$refs.tree.filter(val);
    },
    defaultCategoryType: {
      handler(val) {
        val && (this.curQueryTreeConds.categoryType = val)
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations('customize', ['setCommodityCategoryId', 'setCurCategoryNode', 'setRelationId']),
    init() {
      const { tableName } = this.$route.params
      const copyTables = interceptorsModule.category.tableArr.copyTables
      if (copyTables.includes(tableName)) {
        this.$emit('change', String(this.category.id)); // 框架会以string格式处理，传number会报错，导致赋值有问题
      }
    },
    confirm() {
      const { singleObjectTables, QueryListTables } = interceptorsModule.category.tableArr
      if (!this.isMultiple) {
        const { tableName } = this.$route.params
        const lastLevelTables = singleObjectTables.filter(i => i != 'PS_C_CATEGORY')
        if (lastLevelTables.includes(tableName) || this.isLastNode) {
          // 单对象的商品品类只能选择末级
          /* if (this.category.children) {
            return this.$Message.warning(t('请选择末级节点！'))
          } */
          if (tableName == 'PS_C_PRO') {
            // 用于商品SPU单对象监听, 实时渲染商品属性Tab表单
            this.setCommodityCategoryId(this.category.id);
          }
        }
        if (tableName == 'PS_C_CATEGORY') {
          // 用于商品类目单对象监听
          this.setCurCategoryNode(this.category);
        }
        this.valuedata = this.category.name || this.category.title
        this.$emit('change', this.category.id);
        this.showTree = false;
        // this.$Modal.remove();
        return
      }

      const handler = (key) => {
        return (this.$refs.tree.getCheckedNodes()).reduce((a,b) => {
          a.push(b[key])
          return a
        }, []);
      }

      // title回显在输入框
      const arr = handler('title');
      this.valuedata = arr.join()

      if (QueryListTables.includes(this.$route.params.tableName)) {
        // 列表查询传id
        const arrIds = handler('id');
        this.$emit('change', arrIds);
      } else {
        // 列表查询传title
        this.$emit('change', this.valuedata);
      }
      this.showTree = false;
      this.checkedNode = this.$refs.tree.getCheckedKeys() || []
      this.expandedNode = this.$refs.tree.getCheckedKeys() || []
      this.checkedNodeArr = this.$refs.tree.getCheckedNodes() || []
    },
    handleTreeConds(payload) {
      if (this.$route.params.tableName == 'PS_C_CATEGORY' && this.$route.params.hasOwnProperty('itemId')) { // 商品类目单对象
        const colnames = new Map([
          ['CATEGORY_TYPE', 'categoryType'], // 类目类型
          ['CP_C_PLATFORM_ID', 'platformId'], // 前台类目-平台
        ])
        if (payload) { // 取更新的值
          switch (payload.item.display) {
            case 'OBJ_SELECT':
              this.curQueryTreeConds[colnames.get(payload.item.colname)] = payload.val
              break;
            case 'OBJ_FK':
              this.curQueryTreeConds[colnames.get(payload.item.colname)] = payload.val.length ? payload.val[0].ID : ''
              break;
            default:
              break;
          }
        } else { // 初始取默认值
          let basePanel = this.$store.state[R3.getModuleName()].mainFormInfo.formData.data.addcolums[0]
          basePanel && basePanel.childs.forEach(i => {
            console.log(i)
            switch (i.display) {
              case 'select':
                this.curQueryTreeConds[colnames.get(i.colname)] = i.valuedata
                break;
              case 'text':
                i.isfk && (this.curQueryTreeConds[colnames.get(i.colname)] = i.refobjid)
                break;
              default:
                break;
            }
          })
        }
      } else if (['/SYSTEM/TABLE/PS_C_PRO/23276', '/SYSTEM/TABLE/PS_C_SKU/23281'].includes(this.$route.fullPath)) { // 商品SPU/SKU列表 - 后台类目
        this.curQueryTreeConds.categoryType = 2
      }
    },
    getTreeData() {
      const self = this;
      const { itemId, tableName } = this.$route.params
      this.objid = itemId == undefined ? -1 : itemId == 'New' ? -1 : itemId
      let params = {
        id: this.objid,
        tableName
      }
      params = { ...params, ...this.curQueryTreeConds }
      if (this.curQueryTreeConds.categoryType == '2') {
        delete params.platformId
      }

      // 复制页面带入原明细id查类目列表
      const copyTables = interceptorsModule.category.tableArr.copyTables
      if (copyTables.includes(tableName) && itemId == 'New') {
        let copyId = sessionStorage.getItem(`${tableName}_definedForm_copy_itemId`)
        if (!!copyId) { // 是否是复制页面
          params.id = copyId
        }
      }
      this.loading = true
      self.service.basicData.getGoodsTypeTree(params).then(res => {
        if (res.data.data.code == 0) {
          this.data = res.data.data.data || [];
          if (this.$route.params.hasOwnProperty('itemId')) {
            this.findCategory(this.data)
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    findCategory(data) {
      const { tableName } = this.$route.params
      data.forEach(i => {
        let isSelected = false
        // const tables = ['SG_C_TOC_STRATEGY', 'ST_C_PRO_LOGISTIC_STRATEGY']
        // if (tables.includes(tableName)) {
        //   isSelected = this.options.valuedata == i.id
        // } else {
        isSelected = i.selected
        // }
        if (isSelected) {
          this.valuedata = i.title
          this.category = { id: i.id, title: i.title, children: i.hasOwnProperty('children') }
          if (tableName == 'PS_C_CATEGORY') {
            this.setCurCategoryNode(i)
          }
          if (tableName == 'PS_C_PRO') {
            this.setCommodityCategoryId(this.category.id);
          }
        } else if (i.children && i.children.length){
          this.findCategory(i.children)
        }
      })
    },
    openModal() {
      const { tableName, itemId } = this.$route.params
      const { categoryType, platformId } = this.curQueryTreeConds
      // 选择前台类目时，平台必填
      if (tableName == 'PS_C_CATEGORY' && itemId) {
        if (categoryType == '1' && (platformId == '' || platformId == '-1')) {
          return this.$Message.warning(t('请选择平台'))
        } else {
          this.data = []
          this.getTreeData()
        }
      }
      if (!this.data.length) {
        this.getTreeData()
      }
      this.showTree = true;
    },
    clearInput() {
      if (!this.isMultiple) {
        switch (this.$route.params.tableName) {
          case 'PS_C_PRO':
            this.setCommodityCategoryId('')
            break;
          case 'PS_C_SKU':
            this.setRelationId('')
            break;
          case 'PS_C_CATEGORY':
            this.setCurCategoryNode({})
            break;
        }
      }
      this.category = { id: '', name: '', children: false }
      this.valuedata = ''
      this.$emit('change', undefined);
      this.checkedNode = []
      this.expandedNode = []
    },
    handleNodeClick(data) {
      this.category = { id: String(data.id), name: data.title, children: data.hasOwnProperty('children') }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    }
  },
};
</script>

<style lang="less">
.CATEGORY_NAME {
  .input-wrap {
    position: relative;
    .ark-input-wrapper {
    }
    .ark-icon {
      position: absolute;
      top: 3px;
      &.funnel {
        right: 1px;
      }
      &.clear {
        right: 20px;
      }
    }
  }
}
</style>
